import React from "react";
import EvaListContainer from "containers/eva/EvaListContainer";

const EvaListPage: React.FC = () => {
  return <EvaListContainer />;
};

export default EvaListPage;
